import { api } from './api';

export interface IUserOption {
  id: string;
  name: string;
  nickname?: string;
  email?: string;
  tag?: string;
  // Lotação do usuário (usada para auto-preencher o participante)
  sector_id?: string;
  sector?: string;
  section?: string;
  cost_center?: string;
  branch_id?: string;
  pix_key?: string;
  bank_name?: string;
  bank_agency?: string;
  bank_account?: string;
}

export interface IBranchOption {
  id: string;
  short_name: string;
}

export const usersService = {
  async list(): Promise<IUserOption[]> {
    const response = await api.get<IUserOption[]>('/accesses');
    return response.data;
  },

  async listBranches(): Promise<IBranchOption[]> {
    const response = await api.get<IBranchOption[]>('/branches');
    return response.data;
  },

  async updateBankData(
    userId: string,
    data: {
      pix_key?: string;
      bank_name?: string;
      bank_agency?: string;
      bank_account?: string;
    },
  ): Promise<void> {
    await api.put('/accesses', { id: userId, ...data });
  },
};
